import { QIcon_chevron_bold_left } from '@repo/icons/index'
import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useGTMBasicPageViewEventWithProperties } from '../../../../helpers/gtmHelper'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import { s_blog } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { STUDENT_PAGE_VIEW_ID } from '../../../../modules/ids/gtm/student'
import client from '../../../../modules/sanityClient'
import urls from '../../../../modules/urls'
import { COLORS } from '../../../../modules/vars'
import { BLOG_TAG_QUERY } from '../../../../sanity/groqQueries'
import { BLOG_TAG_QUERYResult } from '../../../../sanity/types'
import EmptyBlock from '../../../common/EmptyBlock'
import LandingNav from '../../navigation/LandingNav'
import Footer from '../../section/footer'
import BlogTagPostListSection from './BlogTagPostListSection'

const TopTitleSection = ({ length }) => {
  const router = useAppRouter()
  const { t } = useTranslation()

  const navigateBackOrRedirect = () => {
    if (typeof window != 'undefined' && window.history.length > 1) {
      router.back()
    } else {
      router.push(urls.student.landing.blog.index)
    }
  }

  return (
    <div className={style.layout}>
      <div className={style.goBackSection} onClick={() => navigateBackOrRedirect()}>
        <QIcon_chevron_bold_left color={COLORS.BLACK} className="h-[16px] w-[16px]" />
        <div>{t(s_blog.search_reult.text_btn)}</div>
      </div>
      <h1 className={style.topTitleSectionTitle}>Tag: {router.query.tag}</h1>
    </div>
  )
}

interface IBlogTagDesktop {
  posts
  isPortal?
}

const BlogTagDesktop = ({ posts, isPortal = false }: IBlogTagDesktop) => {
  const { query, asPath } = useRouter()

  const [blogList, setBlogList] = useState([...posts])

  const cacheKey = (tag, start, end) => ['tag', tag, start, end]

  const fetchFunction = async (start, end) => {
    const params: Record<string, any> = {
      tag: query.tag,
      lang: query.lang,
      start: start,
      end: end,
    }

    const posts: BLOG_TAG_QUERYResult[] = await client.fetch(BLOG_TAG_QUERY, params)

    return posts
  }

  const { data: postsData } = useQuery({ queryKey: cacheKey(query.tag, 0, 8), queryFn: () => fetchFunction(0, 8) })

  useEffect(() => {
    if (postsData) {
      setBlogList(postsData)
    }
  }, [postsData])

  const sendGTMPVEvent = useGTMBasicPageViewEventWithProperties({
    page_id: STUDENT_PAGE_VIEW_ID.LANDING_BLOG_TAG,
    page_title: asPath,
    device_type: 'pc_web',
  })

  useEffect(() => {
    sendGTMPVEvent()
  }, [])

  return (
    <>
      {!isPortal && <LandingNav />}
      <div className={style.pageLayout}>
        <div className={style.bodyWrapper}>
          <TopTitleSection length={posts.length} />
          <BlogTagPostListSection isMobile={false} posts={blogList} cacheKey={cacheKey} fetchFunction={fetchFunction} />
          {isPortal && <EmptyBlock h={120} />}
        </div>
        {!isPortal && <Footer />}
      </div>
    </>
  )
}

export default BlogTagDesktop

const style = {
  layout: ` mb-[68px]`,
  pageLayout: `flex flex-col justify-between text-black`,
  goBackSection: `Body1-16Bd mb-[28px] mt-[40px] flex cursor-pointer flex-row items-center`,
  bodyWrapper: `max-w-1040 relative mx-auto mb-[120px] w-full`,
  topTitleSectionTitle: `Hero2-48Bd flex`,
  topTitleSectionSubtitle: `Headline2-24Md text-gray-700`,
  topTitleSectionResults: `Headline2-24Md text-gray-700`,
}
